<template>
  <div class="pro">
    <div class="top">
      <img class="line" src="../assets/index/line.png" alt="" />
      <div class="title">发展历程</div>
    </div>
    <div class="proTop">
      <!-- 上轮播 -->
      <div class="swiperWrap">
        <div class="arrow" @click="arrowClick('left')">
          <img src="../assets/process/left.png" alt="" />
        </div>
        <!-- 轮播图 -->
        <div class="swiper">
          <img
            v-if="this.$isMobile"
            style="
              position: absolute;
              left: 0;
              top: 5rem;
              width: 100%;
              height: auto;
              background-repeat: no-repeat;
            "
            src="../assets/process/swiperBg.png"
            alt=""
          />
          <el-carousel
            indicator-position="none"
            @change="change"
            ref="cardShow"
            arrow="never"
            :initial-index="activeIndex"
            :autoplay="false"
          >
            <el-carousel-item v-for="(item, index) in datalist" :key="index">
              <div class="contentWrap">
                <div class="right">
                  <div class="year">{{ item.year }}</div>
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.desc }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="arrow" @click="arrowClick('right')">
          <img src="../assets/process/right.png" alt="" />
        </div>
      </div>

      <!-- 下滚动条 -->
      <div class="step">
        <div class="line">
          <!-- 循环的圆点 -->
          <!-- 左图死的 -->
          <div class="circle">
            <!-- <img src="" alt=""> -->
            <img class="circleImg" src="../assets/process/circle.png" alt="" />
            <div class="direc">
              <img
                @click="arrowClick('left')"
                src="../assets/process/arrowRight.png"
                alt=""
              />
            </div>
          </div>
          <div class="circle" v-for="(item, index) in datalist" :key="index">
            <img
              :class="active == index ? 'big' : 'circleImg'"
              :src="active == index ? item.image2 : item.image1"
              alt=""
            />
            <!-- <img src="../assets/ceshi/wechatActive.png" alt="" /> -->
            <div
              @mouseover="changeSwiper(index)"
              :style="{
                fontSize: index == active ? '2rem' : '2rem',
                fontWeight: index == active ? 'bold' : '',
                paddingTop: index == active ? '1.6825rem' : '2.7825rem',
              }"
              class="item"
            >
              {{ item.year }}
              <!-- {{ yeararr[0] + item - 2 }} -->
            </div>
          </div>
          <!-- 有图死的 -->
          <div class="circle">
            <img class="circleImg" src="../assets/process/circle.png" alt="" />
            <div class="direc">
              <img
                @click="arrowClick('right')"
                src="../assets/process/arrowLeft.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 下方文字 -->
    <div class="top">
      <img class="line" src="../assets/index/line.png" alt="" />
      <div class="title" v-html="title">
        <!-- 阁韵在全国拥有服务商100余家 <br />终端用户已覆盖全国 -->
      </div>
      <div class="desc" v-html="desc">
        <!-- 旗下建筑外窗、阳光房、幕墙各铝包木系列产品
        <br />可满足每一位用户的定制需求 -->
      </div>
    </div>
    <div class="map"><img :src="`${image}`" alt="" /></div>
  </div>
</template>

<script>
import { aboutDevelopment } from "../api/request";
export default {
  name: "Process",
  data() {
    return {
      desc: "",
      title: "",
      image: null,
      isMobile: this.$isMobile,
      activeIndex: 0,
      // list: [
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2014",
      //     title: "阁韵公司成立",
      //     desc: "拥有十余年经验的铝包木窗从业者们凝聚在一起，成立哈尔滨阁韵窗业有限公司。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2015",
      //     title: "引进先进生产线",
      //     desc: "公司引进最为先进的木窗加工生产线，包括意大利SCM数控加工设备，国内最为先进的科霖除尘设备，德国FESTOOL砂光系统等",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2016",
      //     title: "生产基地启动",
      //     desc: "阁韵东北区生产基地选址建设完成，总投资2000万元，占地面积30000平方米。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2017",
      //     title: "“家”文化体系",
      //     desc: "阁韵东北区生产基地正式投入使用，阁韵“家”文化体系确立。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2018",
      //     title: "一站式的服务",
      //     desc: "阁韵爆炸式推出GR-95国韵系列、GR-105简合系列、GR-110纤体系列等高端产品。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2019",
      //     title: "国家高新技术企业",
      //     desc: "阁韵窗业被授予国家高新技术企业称号。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2020",
      //     title: "阁韵服务年",
      //     desc: "阁韵推出服务年战略，首创订单可查询系统、全程跟踪生产环节、天猫旗舰店正式上线，打造高端铝包木服务第一品牌。",
      //   },
      //   {
      //     src: require("../assets/process/pic.png"),
      //     year: "2021",
      //     title: "品牌全新升级",
      //     desc: "2021年阁韵品牌全新升级，重点打造“换窗，阁韵更专业”品牌定位。推出第四代门店SI体系，引入建众5A门店管理体系及建众P5招商体系，全面赋能经销商。",
      //   },
      // ],
      // index: 2,
      // year: [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021],
      yeararr: [],
      datalist: [],
      index: 2,

      // 切换图标当前项
      active: 0,
      datalistnum: 0,
    };
  },
  mounted() {
    aboutDevelopment().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        var obj = res.data.data;
        this.desc = obj.desc;
        this.title = obj.title;
        this.image = obj.image;
        this.datalist = obj.list;
        console.log(this.datalist);
        this.datalistnum = this.datalist.length - 1;
        console.log(this.datalistnum);
        // var stringarr = obj.list.map((item) => {
        //   return item.year;
        // });
        // this.yeararr = stringarr.map(Number);
        // this.yeararr = stringarr;
        // console.log(this.yeararr);
      }
    });
  },
  methods: {
    change(index) {
      console.log(index);
      // this.index = index + 2;
    },
    // 鼠标滑过事件
    changeSwiper(index) {
      // 一个对象
      // console.log(item);
      // 索引
      console.log(index);
      this.active = index;

      this.$refs.cardShow.setActiveItem(this.active);
    },
    // 轮播图左右切换
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();

        if (this.active == this.datalistnum) {
          this.active = 0;
        } else {
          this.active++;
        }
      } else {
        this.$refs.cardShow.prev();

        if (this.active == 0) {
          this.active = this.datalistnum;
        } else {
          this.active--;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.pro {
  overflow: hidden;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
    .desc {
      margin-top: 32px;
      font-size: 24px;
      color: #004c31;
    }
    .line {
      width: 90px;
      height: 8px;
    }
  }
  .proTop {
    width: 100%;
    height: 741px;
    background: url("../assets/process/banner.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    padding: 1px;
    .swiperWrap {
      position: relative;
      z-index: 2001;
      width: 1480px;
      margin: 90px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .arrow {
        width: 50px;
        height: 50px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      .swiper {
        position: relative;
        width: 1280px;
        height: 400px;
        background: #ffffff;
        background: url("../assets/process/swiperBg.png") no-repeat;
        background-size: 100% auto;
        background-position: center;
        .contentWrap {
          margin: 76px 70px;
          width: 1129px;
          height: 247px;
          display: flex;
          align-items: center;
          .pic {
            width: 400px;
            height: 247px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            width: 690px;
            margin-left: 70px;
            text-align: left;
            .year {
              font-size: 60px;
              color: #004c31;
            }
            .title {
              margin-top: 24px;
              font-size: 20px;
              color: #004c31;
            }
            .desc {
              margin-top: 12px;
              color: #6c7a77;
              line-height: 36px;
            }
          }
        }
      }
    }
    .step {
      width: 1259px;
      margin: 128px auto 0;
      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1px;
        background: #fff;
        .circle {
          width: 18px;
          height: 18px;
          .circleImg {
            width: 18px;
            height: 18px;
          }
          .big {
            margin-top: -18px;
            width: 50px;
            height: 50px;
          }
          .direc {
            cursor: pointer;
            margin-top: -90px;
            width: 18px;
            height: 18px;
            img {
              width: 18px;
              height: 18px;
            }
          }
          .item {
            // border: 1px solid blue;
            white-space: nowrap;
            // border: 1px solid blue;
            margin-top: -140px;
            cursor: pointer;
            font-size: 27px;
            color: #ffffff;
            margin-left: -10px;
            &:hover {
              font-size: 32px;
              font-weight: bold;
            }
          }
        }
      }
      /*.allYear{*/
      /*    width: 1259px;*/
      /*    margin: 42px auto 0;*/
      /*    display: flex;*/
      /*    align-items: center;*/
      /*    justify-content: space-between;*/
      /*    .item{*/
      /*    }*/
      /*}*/
    }
  }
  .map {
    width: 1425px;
    height: 1028px;
    margin: 63px auto 103px;
    img {
      width: 1425px;
      height: 1028px;
    }
  }
}
@media screen and (max-width: 450px) {
  .pro {
    overflow: hidden;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: 100%;
      padding: 59px 0;
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24px;
      }
      .desc {
        margin-top: 32 * 2px;
        font-size: 24 * 2px;
        color: #004c31;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
    }
    .proTop {
      width: 100%;
      height: 741 * 2px;
      background: url("../assets/process/banner.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      padding: 1px;
      .swiperWrap {
        position: relative;
        z-index: 2001;
        width: 1480 * 1.3px;
        margin: 90px auto 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .arrow {
          width: 50 * 2px;
          height: 50 * 2px;
          img {
            width: 50 * 2px;
            height: 50 * 2px;
          }
        }
        .swiper {
          width: 1280 * 2px;
          height: 400 * 2px;
          background: #ffffff;
          /deep/.el-carousel__container {
            height: 400 * 2px;
          }
          .contentWrap {
            margin: 76px 70px;
            width: 1129 * 2px;
            height: 247 * 2px;
            display: flex;
            align-items: center;
            .pic {
              width: 400 * 2px;
              height: 247 * 2px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right {
              width: 690 * 1.4px;
              margin-left: 70px;
              text-align: left;
              .year {
                font-size: 60px;
                color: #004c31;
              }
              .title {
                margin-top: 24px;
                font-size: 20 * 2px;
                color: #004c31;
              }
              .desc {
                font-size: 24 * 2px;
                margin-top: 12px;
                color: #6c7a77;
                line-height: unset;
              }
            }
          }
        }
      }
      .step {
        width: 1459px;
        margin: 240px auto 0;
        .line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 2px;
          background: #fff;
          .circle {
            margin-top: 0px;
            width: 18 * 2px;
            height: 18 * 2px;
            .circleImg {
              width: 18 * 2px;
              height: 18 * 2px;
            }
            .big {
              margin-top: 0;
              width: 50px;
              height: 50px;
            }
            .direc {
              cursor: pointer;
              margin-top: -150px;
              width: 18 * 2px;
              height: 18 * 2px;
              img {
                width: 18 * 2px;
                height: 18 * 2px;
              }
            }
            .item {
              margin-top: -190px !important;
              cursor: pointer;
              font-size: 20px;
              color: #ffffff;
              margin-left: -30px;
              &:hover {
                font-size: 32 * 2px;
                font-weight: bold;
              }
            }
          }
        }
        /*.allYear{*/
        /*    width: 1259px;*/
        /*    margin: 42px auto 0;*/
        /*    display: flex;*/
        /*    align-items: center;*/
        /*    justify-content: space-between;*/
        /*    .item{*/
        /*    }*/
        /*}*/
      }
    }
    .map {
      width: 1425px;
      height: 1028px;
      margin: 63px auto 103px;
      img {
        width: 1425px;
        height: 1028px;
      }
    }
  }
}
</style>